import { Route } from 'react-router-dom'

import ProfileMiddleware from '../middlewares/ProfileMiddleware'

import PageMessages from '../pages/messages/PageMessages/PageMessages'
import PageChat from '../pages/messages/PageChat/PageChat'
import PageGroup from '../pages/messages/PageGroup/PageGroup'

export const RoutesMessages = [
    <Route path="/messages" element={<ProfileMiddleware><PageMessages /></ProfileMiddleware>} key="route-u-messages" />,
    <Route path="/chat/:id" element={<ProfileMiddleware><PageChat /></ProfileMiddleware>} key="route-u-chat" />,
    <Route path="/chat/g/:chatId" element={<ProfileMiddleware><PageChat isGroup /></ProfileMiddleware>} key="route-u-g" />,
    <Route path="/chat/g/:chatId/info" element={<ProfileMiddleware><PageGroup /></ProfileMiddleware>} key="route-u-g-info" />,
]
